import { render } from "./AgentePickMpio.vue?vue&type=template&id=144bbca2"
import script from "./AgentePickMpio.vue?vue&type=script&lang=ts"
export * from "./AgentePickMpio.vue?vue&type=script&lang=ts"
script.render = render

export default script